import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'kt-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent{

	constructor(
		public dialogRef: MatDialogRef<AlertComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: AlertData) {
	}

	onNoClick(): void {
		this.dialogRef.close();
	}

}

export interface AlertData{
	title: string;
	mensaje: string;
}
